import portaro from '../portaro';

portaro.directive("jpSearchPageSize", ['TEMPLATES_PATH', 'CONTEXT_PATH',
    function(TEMPLATES_PATH, CONTEXT_PATH) {
        return {
            restrict: 'E',
            templateUrl: TEMPLATES_PATH + 'jp-search-page-size.html',
            scope: {
                currentSize: '=',
                availableSizes: '=',
                onChange: '='
            },
            link: function ($scope) {
                $scope.CONTEXT_PATH = CONTEXT_PATH;
                $scope.model = $scope.currentSize;
            }
        };
    }]);